import { gql } from '@apollo/client';

export interface GetBasicStrokesResponse {
    basicStrokes: {
        id: string;
        code: string;
        locale: string;
        character: string;
    }[];
}

export interface GetBasicStrokesVariables {
    where: {
        character: {
            contains: string;
        };
        locale: {
            equals: string;
        };
    };
}

export const GET_BASIC_STROKES = gql`
    query BasicStrokes($where: BasicStrokeWhereInput!) {
        basicStrokes(where: $where) {
            id
            code
            locale
            character
        }
    }
`;
